import axios from 'axios'
import { getJWT } from '../utils/functions'

const iseeBaseURL = import.meta.env.VITE_BACKEND
const flowvuBaseURL = import.meta.env.VITE_FLOWVU_BACKEND
const chatvuBaseURL = import.meta.env.VITE_CHATVU_BACKEND

const requestFunction = async (config) => {
  const token = await getJWT().catch(() => {
    window.location.reload(false)
  })
  if (token) {
    // Ensure headers object exists
    if (!config.headers) {
      config.headers = {}
    }
    // For axios, use config.headers directly (not config.headers.common)
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}

const errorFunction = async (error) => {
  // Do something with request error
  return Promise.reject(error)
}

const headers = {
  'Content-Type': 'application/json'
}

const iseeInstance = axios.create({
  baseURL: iseeBaseURL,
  timeout: 10000, // timeout selected to accomodate portal loading
  headers
})

const flowvuInstance = axios.create({
  baseURL: flowvuBaseURL,
  timeout: 30000, // timeout selected to accomodate large file upload
  headers
})

const chatvuInstance = axios.create({
  baseURL: chatvuBaseURL,
  timeout: 30000,
  headers
})

iseeInstance.interceptors.request.use(requestFunction, errorFunction)
flowvuInstance.interceptors.request.use(requestFunction, errorFunction)
chatvuInstance.interceptors.request.use(requestFunction, errorFunction)

export { iseeInstance, flowvuInstance, chatvuInstance }
